import Draggable, { DraggableEventHandler } from 'react-draggable';
import React from 'react';
import { Row, Col } from 'reactstrap';

import 'style/configurator/Modal.css';

const DraggableModal = ({
  children,
  closeModalNotSaved,
  wallCoordinates,
  id,
  onDrag,
}: {
  children: JSX.Element[];
  closeModalNotSaved: () => void;
  wallCoordinates?: any;
  id?: string;
  onDrag?: DraggableEventHandler;
}): JSX.Element => (
  <Draggable cancel=".text-field" onDrag={onDrag}>
    <div className="properties-edit-popup" id={id}>
      <Row>
        <Col>
          <h2
            onClick={() =>
              closeModalNotSaved !== undefined ? closeModalNotSaved() : null
            }
          >
            &times;
          </h2>
        </Col>
      </Row>
      {children}
    </div>
  </Draggable>
);

export default DraggableModal;
